import { z } from 'zod';

/**
 * The anchor argument, accepted under BOTH names for one release.
 *
 * dash-meta renamed it `entityType` -> `entityTypeAnchor` so the four reads and
 * the four client tools stop carrying two names for one enum. The two apps
 * deploy separately and an open tab outlives a backend rollout, so a tool that
 * accepted only one name would dead-end on a parse error for every user in the
 * skew window. Drop the `entityType` half once a release has shipped carrying
 * both.
 */
export const entityTypeAnchorFields = {
  entityTypeAnchor: z.string().optional(),
  entityType: z.string().optional(),
};

/** Empty when neither arrives, which the run bodies already refuse by scope. */
export function readEntityTypeAnchor(input: {
  entityTypeAnchor?: string;
  entityType?: string;
}): string {
  return input.entityTypeAnchor ?? input.entityType ?? '';
}
